/* Stained Allegiance — theme behaviour
   Everything degrades gracefully: if JS fails, forms still post and links still navigate. */
(function () {
  'use strict';
  var cfg = window.SATheme || {};
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ---------- overlays ---------- */
  function openPanel(el) {
    if (!el) return;
    el.classList.add('on');
    el.setAttribute('aria-hidden', 'false');
    var sc = $('[data-scrim]'); if (sc) sc.classList.add('on');
    document.body.style.overflow = 'hidden';
  }
  function closeAll() {
    $$('.drawer').forEach(function (d) { d.classList.remove('on'); d.setAttribute('aria-hidden', 'true'); });
    var sc = $('[data-scrim]'); if (sc) sc.classList.remove('on');
    document.body.style.overflow = '';
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-scrim]') || e.target.closest('[data-close]')) { closeAll(); return; }
    var mn = e.target.closest('[data-open-nav]');
    if (mn) { e.preventDefault(); openPanel($('#MobileNav')); return; }
    var ct = e.target.closest('[data-open-cart]');
    if (ct && cfg.cartDrawer) { e.preventDefault(); openPanel($('#CartDrawer')); return; }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });

  /* ---------- cart drawer refresh ---------- */
  function refreshCart() {
    return fetch(window.location.pathname + '?sections=cart-drawer', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var host = $('#CartDrawerHost');
        if (host && data && data['cart-drawer']) {
          var wasOpen = $('#CartDrawer') && $('#CartDrawer').classList.contains('on');
          host.innerHTML = data['cart-drawer'];
          if (wasOpen) openPanel($('#CartDrawer'));
        }
        return data;
      });
  }
  function bumpCount(n) {
    $$('[data-cart-count]').forEach(function (el) { el.textContent = n; });
  }

  /* ---------- add to cart ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[action*="/cart/add"]');
    if (!form || !cfg.routes) return;
    e.preventDefault();
    var btn = form.querySelector('[data-add-btn]');
    var label = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
    fetch(cfg.routes.cart_add, {
      method: 'POST',
      headers: { 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: new FormData(form)
    })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function () { return refreshCart(); })
      .then(function () {
        return fetch(cfg.routes.cart + '.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        bumpCount(cart.item_count);
        if (cfg.cartDrawer) openPanel($('#CartDrawer')); else window.location.href = cfg.routes.cart;
      })
      .catch(function () { form.submit(); })
      .finally(function () { if (btn) { btn.disabled = false; btn.textContent = label; } });
  });

  /* ---------- cart line quantity ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-line-change]');
    if (!b || !cfg.routes) return;
    e.preventDefault();
    var line = b.getAttribute('data-line');
    var qty = b.getAttribute('data-qty');
    fetch(cfg.routes.cart_change, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: Number(line), quantity: Number(qty) })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) { bumpCount(cart.item_count); return refreshCart(); })
      .catch(function () { window.location.href = cfg.routes.cart; });
  });

  /* ---------- quantity steppers ---------- */
  document.addEventListener('click', function (e) {
    var s = e.target.closest('[data-qty-step]');
    if (!s) return;
    var wrap = s.closest('.qty');
    var input = wrap && wrap.querySelector('input');
    if (!input) return;
    var next = parseInt(input.value || '1', 10) + parseInt(s.getAttribute('data-qty-step'), 10);
    input.value = Math.max(1, next);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- product gallery ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-thumb]');
    if (!t) return;
    var gal = t.closest('[data-gallery]');
    var main = gal && gal.querySelector('[data-gallery-main] img');
    if (!main) return;
    main.src = t.getAttribute('data-src');
    main.srcset = '';
    $$('[data-thumb]', gal).forEach(function (b) { b.classList.remove('on'); });
    t.classList.add('on');
  });

  /* ---------- variant picking ---------- */
  $$('[data-variants]').forEach(function (root) {
    var data;
    try { data = JSON.parse(root.querySelector('[data-variant-json]').textContent); } catch (err) { return; }
    var idInput = root.querySelector('[data-variant-id]');
    var priceEl = root.querySelector('[data-price]');
    var compareEl = root.querySelector('[data-compare]');
    var btn = root.querySelector('[data-add-btn]');

    function money(cents) {
      var v = (cents / 100).toFixed(2);
      return '$' + v.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }
    function selected() {
      return $$('[data-option-group]', root).map(function (g) {
        var on = g.querySelector('.chip.on');
        return on ? on.getAttribute('data-value') : null;
      });
    }
    function update() {
      var chosen = selected();
      var match = data.find(function (v) {
        return v.options.every(function (o, i) { return chosen[i] == null || o === chosen[i]; });
      });
      if (!match) return;
      if (idInput) idInput.value = match.id;
      if (priceEl) priceEl.textContent = money(match.price);
      if (compareEl) {
        if (match.compare_at_price && match.compare_at_price > match.price) {
          compareEl.textContent = money(match.compare_at_price);
          compareEl.hidden = false;
        } else { compareEl.hidden = true; }
      }
      if (btn) {
        btn.disabled = !match.available;
        btn.textContent = match.available ? btn.getAttribute('data-label-available') : btn.getAttribute('data-label-sold');
      }
      if (window.history.replaceState) {
        var u = new URL(window.location.href);
        u.searchParams.set('variant', match.id);
        window.history.replaceState({}, '', u);
      }
    }
    root.addEventListener('click', function (e) {
      var c = e.target.closest('.chip[data-value]');
      if (!c) return;
      e.preventDefault();
      var group = c.closest('[data-option-group]');
      $$('.chip', group).forEach(function (x) { x.classList.remove('on'); });
      c.classList.add('on');
      update();
    });
    update();
  });

  /* ---------- announcement bar duplication for seamless scroll ---------- */
  $$('[data-announce-track]').forEach(function (track) {
    if (track.children.length === 1) track.appendChild(track.firstElementChild.cloneNode(true));
  });
})();
